class ProductRecommend {
  constructor(parent) {
    this.parent = parent;
    if (parent.length === 0) {
      return;
    }
    document.addEventListener("DOMContentLoaded", () => this.swiperSlider());
    this.init();
  }

  swiperSlider = () => {
    var swiper = new Swiper(".recommend-collections-js", {
      slidesPerView: 4,
      spaceBetween: 10,
      mousewheel: true,
      infinite:true,
      autoplay: true,
      mousewheel: false,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".recommend-product-next",
        prevEl: ".recommend-product-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 10,
        },
      },
    });
  };

  checkDiv = () => {
    var count = setInterval(() => {
      let swipeDiv = document.querySelector(".recommend-collections-js");
      if (swipeDiv) {
        this.swiperSlider();
        clearInterval(count);
      }
    }, 1000)
  };
  
  init = () => {
    this.checkDiv();
  };
}
new ProductRecommend(document.querySelectorAll(".product-recommendations"));
